import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

import { MenuUtility } from '../../utilities/menu.utility';
import { Select2Utility } from '../../utilities/select2.utility';

@Component({
  selector: 'shared-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit {

  @Input() user : string;
  @Output() eventContinue = new EventEmitter<any>();

  constructor( ) {  }

  ngOnInit() {
    //consumir ws de contratos
    MenuUtility.selectOption(null);
    Select2Utility.refresh();    
  }

  continuar(){
    this.eventContinue.emit({'message' : 'prueba desde subcomponent contract'});
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/contract/contract.component.ts